import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewEquipoWm= () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'equipo_wm',
        name: 'Equipo wm',
        component: ViewEquipoWm,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
